function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Node, mergeAttributes, textblockTypeInputRule } from '@tiptap/core';
/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */

var Heading = Node.create({
  name: 'heading',
  addOptions: function addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: 'inline*',
  group: 'block',
  defining: true,
  addAttributes: function addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false
      }
    };
  },
  parseHTML: function parseHTML() {
    return this.options.levels.map(function (level) {
      return {
        tag: "h".concat(level),
        attrs: {
          level: level
        }
      };
    });
  },
  renderHTML: function renderHTML(_ref) {
    var node = _ref.node,
        HTMLAttributes = _ref.HTMLAttributes;
    var hasLevel = this.options.levels.includes(node.attrs.level);
    var level = hasLevel ? node.attrs.level : this.options.levels[0];
    return ["h".concat(level), mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setHeading: function setHeading(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;

          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }

          return commands.setNode(_this.name, attributes);
        };
      },
      toggleHeading: function toggleHeading(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;

          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }

          return commands.toggleNode(_this.name, 'paragraph', attributes);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return this.options.levels.reduce(function (items, level) {
      return _objectSpread(_objectSpread({}, items), _defineProperty({}, "Mod-Alt-".concat(level), function ModAlt() {
        return _this2.editor.commands.toggleHeading({
          level: level
        });
      }));
    }, {});
  },
  addInputRules: function addInputRules() {
    var _this3 = this;

    return this.options.levels.map(function (level) {
      return textblockTypeInputRule({
        find: new RegExp("^(#{".concat(Math.min.apply(Math, _toConsumableArray(_this3.options.levels)), ",").concat(level, "})\\s$")),
        type: _this3.type,
        getAttributes: {
          level: level
        }
      });
    });
  }
});
export { Heading, Heading as default };